export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white pt-20 sm:pt-24 lg:pt-0">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgb(20, 184, 166) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 lg:py-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-block bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              Spécialiste B2B - Syndics, Agences & AIS
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Réparation de Châssis PVC, Alu & Bois - Bruxelles & Brabant Wallon
            </h1>

            <p className="text-lg sm:text-xl text-gray-700 mb-4 leading-relaxed">
              Expert en quincaillerie de châssis toutes marques (Winkhaus, Roto, GU, MACO). Réparation de mécanismes, crémones, renvois d'angle et réglages complexes.
            </p>

            <p className="text-base sm:text-lg text-gray-600 mb-8 leading-relaxed">
              Diagnostic vidéo WhatsApp gratuit pour une réactivité maximale.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-4 mb-8 max-w-md">
              <a
                href="https://wa.me/32475585219"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-teal-500 text-white px-6 py-4 rounded-lg text-sm font-semibold hover:bg-teal-600 transition-all shadow-lg hover:shadow-xl inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl mr-2"></i>
                <span>Prendre RDV pour un diagnostic</span>
              </a>
              <a
                href="#calculateur"
                className="bg-white text-teal-600 px-6 py-4 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-all border-2 border-teal-500 inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('calculateur')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-calculator-line text-xl mr-2"></i>
                <span>Estimer une Intervention</span>
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap items-center gap-4 sm:gap-6 text-sm text-gray-600 mb-6">
              <div className="flex items-center">
                <i className="ri-time-line text-teal-500 text-xl mr-2"></i>
                <span>Intervention sous 48h</span>
              </div>
              <div className="flex items-center">
                <i className="ri-shield-check-line text-teal-500 text-xl mr-2"></i>
                <span>Garantie 2 ans</span>
              </div>
              <div className="flex items-center">
                <i className="ri-camera-line text-teal-500 text-xl mr-2"></i>
                <span>Rapport photo avant/après</span>
              </div>
            </div>

            {/* Social Proof - Reviews */}
            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-lg border border-gray-100">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className="ri-star-fill text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <p className="text-xl sm:text-2xl font-bold text-gray-900">4.9/5</p>
                    <p className="text-xs sm:text-sm text-gray-600">Note moyenne</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-xl sm:text-2xl font-bold text-teal-600">150+</p>
                  <p className="text-xs sm:text-sm text-gray-600">Clients satisfaits</p>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 pt-4 border-t border-gray-100">
                <div className="flex items-center gap-2">
                  <img 
                    src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg" 
                    alt="Google" 
                    className="h-4 sm:h-5"
                  />
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-yellow-400 text-sm"></i>
                    <span className="text-sm font-semibold text-gray-900">4.9</span>
                    <span className="text-xs text-gray-500">(87 avis)</span>
                  </div>
                </div>
                
                <div className="hidden sm:block w-px h-6 bg-gray-200"></div>
                
                <div className="flex items-center gap-2">
                  <img 
                    src="https://upload.wikimedia.org/wikipedia/commons/6/69/Trustpilot_Logo.svg" 
                    alt="Trustpilot" 
                    className="h-4 sm:h-5"
                  />
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-green-500 text-sm"></i>
                    <span className="text-sm font-semibold text-gray-900">4.8</span>
                    <span className="text-xs text-gray-500">(63 avis)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative mt-8 lg:mt-0">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[400px] sm:h-[500px] lg:h-[600px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/105da1a2289d14ccbfd9e2dd071cd9e0.jpg"
                  alt="Technicien professionnel réparant un châssis"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              
              {/* Floating Card */}
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 right-4 sm:right-6 bg-white/95 backdrop-blur-sm rounded-xl p-4 sm:p-6 shadow-xl">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs sm:text-sm text-gray-600 mb-1">Partenaire de confiance</p>
                    <p className="text-lg sm:text-2xl font-bold text-teal-600">150+ Syndics & Agences</p>
                  </div>
                  <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                    <i className="ri-building-line text-2xl sm:text-3xl text-teal-600"></i>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-teal-200 rounded-full opacity-50 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-teal-300 rounded-full opacity-30 blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}